import {useEffect} from 'react';

function DataWindow(props) {
    useEffect(() => {
        // Ensure the opener still exists and is not closed
        if (window.opener && !window.opener.closed) {
            // Send data: (message, targetOrigin)
            // Use a specific origin (e.g., 'https://your-domain.com') instead of '*' for security
            window.opener.postMessage(window.location.href, "*");
        }
    }, []);
    return null
}

export default DataWindow;
